"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getUniqueId_1 = (0, tslib_1.__importDefault)(require("./getUniqueId"));
function getUniqueClassName(classImportName) {
    return "wix-playable--".concat((0, getUniqueId_1.default)(classImportName));
}
function generateClassNames(rules) {
    return Object.keys(rules).reduce(function (acc, classImportName) {
        var _a;
        return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, acc), (_a = {}, _a[classImportName] = getUniqueClassName(classImportName), _a)));
    }, {});
}
exports.default = generateClassNames;
//# sourceMappingURL=generateClassNames.js.map